import { Image } from '@winnin/winnin_ui.components.image'
import { TooltipWithPortal } from '@winnin/winnin_ui.components.tooltip-with-portal'

import Briefing from 'assets/images/svg/briefing.svg'
import { useTranslate } from 'lib/tolgee'
import './index.scss'
import { TOLGEE_GLOBALS } from 'utils'

export function CardThumbnail({ thumbnails = [], isBriefing = false }) {
  const t = useTranslate()
  const limitedThumbnails = thumbnails.slice(0, 3)

  return (
    <div className={`CardThumbnail board-grid-${limitedThumbnails?.length}`}>
      {limitedThumbnails?.map((thumb, index) => (
        <div key={`${thumb}-${index}`} className={`board-grid-place-${index + 1} place`}>
          <Image src={thumb} alt="" />
        </div>
      ))}
      {isBriefing && (
        <div className={'isBriefingCard'}>
          <TooltipWithPortal tooltipMessage={t(TOLGEE_GLOBALS.briefing)}>
            <Image src={Briefing} alt="Briefing" />
          </TooltipWithPortal>
        </div>
      )}
    </div>
  )
}
